import { render, staticRenderFns } from "./DiplomacyIcons.vue?vue&type=template&id=65710192&scoped=true&"
import script from "./DiplomacyIcons.vue?vue&type=script&lang=js&"
export * from "./DiplomacyIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65710192",
  null
  
)

export default component.exports